import { render } from "./RequetesNotInJeu.vue?vue&type=template&id=f904e24c"
import script from "./RequetesNotInJeu.vue?vue&type=script&lang=js"
export * from "./RequetesNotInJeu.vue?vue&type=script&lang=js"

import "./RequetesNotInJeu.vue?vue&type=style&index=0&id=f904e24c&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__